import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { State } from '../../core/state';
import * as UserActions from '../../core/state/users/user.actions';
import {
  selectIsImpersonating,
  selectUser,
} from '../../core/state/users/user.selectors';

@Component({
  selector: 'black-impersonation-banner',
  templateUrl: './impersonation-banner.component.html',
  standalone: false,
})
export class ImpersonationBannerComponent {
  private store = inject<Store<State>>(Store);

  readonly isImpersonating$: Observable<boolean> = this.store.select(selectIsImpersonating);
  readonly user$: Observable<any> = this.store.select(selectUser);

  endImpersonation(): void {
    this.store.dispatch(UserActions.endImpersonation());
  }

  getUserDisplayName(user: any): string {
    if (user?.name?.firstName) {
      return `${user.name.firstName} ${user.name.lastName ?? ''}`.trim();
    }
    if (user?.profile?.personal?.firstName) {
      return `${user.profile.personal.firstName} ${user.profile.personal.lastName ?? ''}`.trim();
    }
    return user?.username ?? 'Unknown User';
  }
}
